const splashTypes= {
    SPLASH:"SPLASH",
};

export default splashTypes;
